import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '../components/legal-page';

export const Route = createFileRoute('/baa')({
  component: BaaPage,
});

function BaaPage() {
  return (
    <LegalPage
      title="Business Associate Agreement"
      lead="LYN Rx signs a Business Associate Agreement with every customer."
    >
      <p>
        A standard, public-facing BAA template will live here once finalized with counsel.
      </p>
      <p>
        Until then, the current BAA is available on request — email{' '}
        <a className="text-primary underline" href="mailto:hello@lynrx.co">
          hello@lynrx.co
        </a>{' '}
        and we'll send a copy for your compliance team to review.
      </p>
    </LegalPage>
  );
}
